import React from 'react';
import logo from './logo.svg';
import ainstags from './ainstags.svg';
import './logo.css';
import classNames from 'classnames';

const Logo = (props) => {
	const {modifier} = props;
	const LogoClass = classNames({
		logo: true,
		[`logo--${modifier}`]: !!modifier
	});
	return (
		<div className={LogoClass}>
			<img src={logo} className="logo__sharp" alt="logo sharp"/>
			<img src={ainstags} className="logo__ainstags" alt="logo ainstags"/>
		</div>
	);
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js